
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { UserModule } from '../../store/modules/user'
import { getCookie, setCookie } from '../../utils/publish'
@Component({ name: 'DashboardHeader' })
export default class DashboardHeader extends Vue {
    time = [new Date(<any>new Date() - 1000 * 60 * 60 * 24 * 30), new Date()]
    instrumentTypes: any = []
    teacherType: any = []
    campusType: any = []
    instrumentArr: any = []
    teacherArr: any = []
    campusArr: any = []

    async getInstrumentType() { // 乐器类型
      const res = await UserModule.InstrumentType()
      this.instrumentArr = res.data.list
    }

    async teacher() {
      const res = await UserModule.getTeacher()
      this.teacherArr = res.data.list
    }

    async campus() {
      const res = await UserModule.getSchool()
      this.campusArr = res.data.list
    }

    instrumentChange(val) {
      this.instrumentTypes = val
      setCookie('instrumentTypes', JSON.stringify(val), 1)
      this.dataChange()
    }
    schoolChange(val) {
      this.campusType = val
      setCookie('campusType', JSON.stringify(val), 1)
      this.dataChange()
    }
    teacherChange(val) {
      this.teacherType = val
      setCookie('teacherType', JSON.stringify(val), 1)
      this.dataChange()
    }
    changeTime(val) {
      if (val) {
        const end = new Date(Date.parse(<any>new Date(val[1])) + 24 * 60 * 60 * 1000 - 1000)
        this.time = [val[0], end]
      } else {
        this.time = []
      }
      setCookie('time', JSON.stringify(this.time), 1)
      this.dataChange()
    }
    dataChange() {

      this.$emit('data-change', {
        instrumentTypes: this.instrumentTypes,
        campusType: this.campusType,
        teacherType: this.teacherType,
        time: this.time
      })
    }

    mounted() {
      const from = this.$route.query.from
      let time: any = this.$route.query.time ? JSON.parse(<any>this.$route.query.time) : []
      let campus: any = this.$route.query.campus ? JSON.parse(<any>this.$route.query.campus) : []
      let teacher: any = this.$route.query.teacher ? JSON.parse(<any>this.$route.query.teacher) : []
      let key = this.$route.query.key
      let value = this.$route.query.value
      let instrument: any = this.$route.query.instrument ? JSON.parse(<any>this.$route.query.instrument) : []
      if (from) {
        if (key === 'instrument_type_id' && value) {
          this.instrumentTypes = value
        } else {
          this.instrumentTypes = instrument
        }
        this.teacherType = teacher
        this.campusType = campus
        this.time = time
      } else {
        this.instrumentTypes = JSON.parse(getCookie('instrumentTypes'))
        this.teacherType = JSON.parse(getCookie('teacherType'))
        this.campusType = JSON.parse(getCookie('campusType'))
        if (getCookie('time') == '[]') {
          this.time = []
        } else {
          this.time = JSON.parse(getCookie('time'))
        }
      }
      
      this.dataChange()
      this.getInstrumentType()
      this.teacher()
      this.campus()
    }
}
